/*!

=========================================================
* Vue Light Bootstrap Dashboard - v1.4.2
=========================================================

* Product Page: http://www.creative-tim.com/product/vue-light-bootstrap-dashboard-pro
* Copyright 2022 Creative Tim (http://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import LightBootstrap from './light-bootstrap-main'

// Plugins
import App from './App.vue'

// router setup
import routes from './routes/routes'

// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('jwt');
  if (to.matched.some(route => route.meta.requiresAuth) && !token) {
    next('/login'); // Redirect to login page if token is missing for protected route
  } else {
    next();
  }
});

const checkToken = () => {
  let token = JSON.parse(localStorage.getItem('jwt'));
  if (Date.now() > token.expiry) {
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    window.location.href = '/#/login';
  }
}

// global variables
Vue.prototype.$systemVariables = {
  apiUrl: 'https://api.editorialkings.com/public/api/v1/',
  recordDeletedSuccessfully: 'Registro eliminado correctamente',
  recordCreatedSuccessfully: 'Registro creado correctamente',
  recordUpdatedSuccessfully: 'Registro actualizado correctamente',
  deleteRecordTitle: '¿Está seguro de que desea eliminar el registro seleccionado?',
  deleteRecordIrreversible: 'Esta acción no se puede revertir',
  yesDeleteIt: 'Sí, eliminar',
  cancel: 'Cancelar',
  wereSorry: 'Lo sentimos',
  loginError: 'Se produjo un error al iniciar sesión',
}

Vue.prototype.$checkToken = checkToken;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})
